var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "#5070DE",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.999 24.499C22.4488 24.499 23.624 23.3238 23.624 21.874C23.624 20.4243 22.4488 19.249 20.999 19.249C19.5493 19.249 18.374 20.4243 18.374 21.874C18.374 23.3238 19.5493 24.499 20.999 24.499Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0548 28.8741H22.9433C25.6742 28.8741 27.04 28.8741 28.0209 28.2309C28.4442 27.9537 28.8088 27.5957 29.0937 27.1774C29.749 26.2149 29.749 24.8736 29.749 22.1926C29.749 19.5116 29.749 18.1702 29.0937 17.2077C28.8088 16.7894 28.4442 16.4314 28.0209 16.1542C27.3909 15.7403 26.6017 15.5924 25.3933 15.5399C24.8167 15.5399 24.3205 15.1112 24.2077 14.5556C24.1214 14.1486 23.8973 13.7838 23.5731 13.523C23.249 13.2622 22.8448 13.1213 22.4288 13.1241H19.5693C18.7048 13.1241 17.9602 13.7234 17.7904 14.5556C17.6775 15.1112 17.1814 15.5399 16.6048 15.5399C15.3973 15.5924 14.608 15.7412 13.9771 16.1542C13.5541 16.4315 13.1899 16.7895 12.9053 17.2077C12.249 18.1702 12.249 19.5107 12.249 22.1926C12.249 24.8744 12.249 26.2141 12.9044 27.1774C13.1879 27.5939 13.5519 27.9518 13.9771 28.2309C14.958 28.8741 16.3239 28.8741 19.0548 28.8741Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.124 19.249H26.249",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.b7f1b4c1dd0293ee4e25cd8fd930900d.svg";
export { ForwardRef as ReactComponent };